<div class="inkasso">
  <div class="inkasso__card" *ngIf="!loading">
    <div class="inkasso__header">
      <div class="inkasso__badge">Inkasso</div>
      <img class="inkasso__logo" [src]="logo" alt="SAMpoolen">
    </div>
    <h1 class="sam-page-heading">Inkassobeslut</h1>

    <ng-container *ngIf="info?.isValid && !result">
      <p class="inkasso__lead">Du har valt:</p>
      <div class="inkasso__choice">{{ info?.decisionLabel }}</div>
      <div class="inkasso__meta">Faktura: <span>{{ info?.invoiceNumber || info?.invoiceId }}</span></div>

      <div class="inkasso__divider"></div>
      <p class="inkasso__note">Bekräfta ditt val för att vi ska kunna hantera fakturan enligt din instruktion.</p>

      <button class="inkasso__button" (click)="confirm()" [disabled]="confirming">
        {{ confirming ? 'Bekräftar...' : 'Bekräfta' }}
      </button>
      <p class="inkasso__hint">Denna sida kräver ingen inloggning.</p>
    </ng-container>

    <ng-container *ngIf="result">
      <p class="inkasso__lead" [class.inkasso__lead--error]="!result.success">
        {{ result.message || (result.success ? 'Ditt val är registrerat.' : 'Något gick fel.') }}
      </p>
      <div class="inkasso__divider"></div>
      <p class="inkasso__hint">Om du behöver hjälp, kontakta support.</p>
    </ng-container>

    <ng-container *ngIf="!info?.isValid && !result">
      <p class="inkasso__lead inkasso__lead--error">{{ info?.message || 'Länken är inte giltig.' }}</p>
      <div class="inkasso__divider"></div>
      <p class="inkasso__hint">Om du behöver hjälp, kontakta support.</p>
    </ng-container>
  </div>

  <div class="inkasso__card inkasso__card--loading" *ngIf="loading">
    <div class="inkasso__header">
      <div class="inkasso__badge">Inkasso</div>
      <img class="inkasso__logo" [src]="logo" alt="SAMpoolen">
    </div>
    <h1 class="sam-page-heading">Inkassobeslut</h1>
    <div class="inkasso__skeleton inkasso__skeleton--title"></div>
    <div class="inkasso__skeleton inkasso__skeleton--choice"></div>
    <div class="inkasso__skeleton inkasso__skeleton--meta"></div>
  </div>
</div>
